export enum NotificationType {
    Info,
    Error,
    Success,
    Warning,
}

export enum InvitationStatus {
    ToBeSent = 1,
    Accepted,
    AwaitingAcceptance,
    Deactivated,
    Declined,
}

export enum FolderType {
    UNKNOWN = -1,
    INBOX = 1,
    SENT = 2,
    SPAM = 3,
    ARCHIVE = 4,
    DOCUMENTREQUEST = 6
}
export enum MessageStatus {
    None = 0,
    DeletedBySender = 1,
    Canceled = 2,
    Pending = 3,
}
export enum ArchiveFolderType {
    UNKNOWN = 0,
    MESSAGE = 1,
    FOLDER = 2,
}

export enum SendMethodWindow {
    METHOD_SELECT,
    QUESTION_ANSWER,
    ACCESSCODE,
    LOGINPASSWORD,
}
export enum SendType {
    Link,
    SecurePDF,
}

export enum DropOff {
    No,
    Yes,
}

export enum UserGroup {
    None = 0,
    Admin = 1,
    Staff = 2,
    Partner = 3,
    Signatures = 4,
}

export enum MessageSource {
    UNKNOWN = -1,
    MAILBOX = 0,
    DROPOFF = 1,
    WEBADDIN = 2,
}

export enum AuthenticationMethod {
    UNKNOWN = -1,
    ACCESSCODE = 0,
    // LOGINPASSWORD = 1,
    QUESTIONANSWER = 2,
    SENDSECUREPDF = 3,
}
export enum LockType {
    Link = 0,
    User = 1,
}

export enum PasswordType {
    Manual = "Manual",
    Random = "Random",
}

export enum SettingMode {
    USER = 0,
    COMPANY = 1,
    BOTH = 2,
}

export enum QuestionType {
    USER = 0,
    COMPANY = 1,
}

export enum PasswordRetrievalMode {
    SecurityQuestion = 0,
    SSNOrEIN = 1,
    PINCode = 2,
    Email = 3,
}

export enum LogoOptions {
    CompanyLogo = 0,
    SafeSendLogo = 1,
    CompanyText = 2,
}

export enum MpiFolder {
    Inbox = 1,
    Sent = 2,
    Archive = 3,
    Spam = 4,
}

export enum ValidationType {
    INVALID = 0,
    VALID = 1,
    WARNING = 2,
}

export enum MessageActions {
    Reply = 1,
    ReplyAll = 2,
    Forward = 3,
    New = 4,
    QuickReply = 5,
}
export enum MessageType {
    UNKNOWN = 0,
    INBOX = 1,
    SENT = 2,
    FORWARD = 4,
}

export enum RecipientType {
    ToRecipient = 1,
    CcRecipient = 2,
}

export enum UnlockType {
    Messages = 1,
    Requests = 2,
}

export enum ArchiveType {
    RIH = 1,
    SIH = 2,
}

export enum ReportColumns {
    Sender,
    Recipient,
    AccessDate,
    LinkStatus,
    SentDate,
    FileName,
    MethodOfTransfer,
    SenderEmail,
}

export enum DownloadedFrom {
    MailBox_Download_SingleFile = 1,
    MailBox_Download_MultipleFile,
    MPI_Download_Inbox_Single_File,
    MPI_Download_Inbox_Multiple_File,
    MPI_Download_SentItem_Single_File,
    MPI_Download_SentItem_Multiple_File,
    MPI_Download_Archive_Single_File,
    MPI_Download_Archive_Multiple_File,
    Send_Link_Download_Single_File,
    Send_Link_Download_Multiple_File,
}

export enum CompanySettingsName {
    SupportContactSettings = 1,
    SentMessageHistorySettings = 2,
    ReceivedMessageHistorySettings = 3,
    RetentionSettings = 4,
    DropOffSettings = 5,
    MessageSecurityQuestionSettings = 6,
    AuthenticationMethodSettings = 7,
    NotificationsSettings = 8,
    RequestHistorySettings = 9,
    RequestNotificationSettings = 10,
    SavedMessageTemplateSettings = 11,
    SavedMessageDRTemplateSettings = 12,
    FolderNotificationSettings = 13,
    FileTypeSettings = 14,
}

export enum FolderColumnName {
    FOLDERNAME = 1,
    EXPIRESDAYS,
}
export enum TemplateColumnName {
    NAME = 1,
    DESCRIPTION = 2,
    CREATEDDATE = 3,
    MODIFIEDDATE = 4,
}

export enum SortOrder {
    ASC = 1,
    DESC,
}

export enum SettingType {
    ADMIN = 1,
    USER = 2,
}

export enum MessageTab {
    Compose = 0,
    Options = 1,
    Preview = 2,
}
export enum FilterType {
    RIH = 1,
    SIH = 2,
    DRH = 3,
}
export enum LinkStatus {
    Active = 1,
    Cancelled = 2,
    Expired = 3,
}

export enum RequestStatus {
    Active = 1,
    Cancelled = 2,
    Expired = 3,
}

export enum MethodOfTransfer {
    DropOff = 1,
    PortalQA = 2,
    PortalAccessCode = 3,
    WebAddInQA = 4,
    WebAddInAccessCode = 5,
    FolderDropOff = 6
}

export enum DateType {
    All = 1,
    Last30Days = 2,
    Last12Months = 3,
    Custom = 4,
}

export enum DetailedStatus {
    NONE = 0,
    OPEN = 1,
    COMPLETED = 2,
    FAILED = 3,
    REOPEN = 4,
}
export enum ListingStatus {
    NONE = 0,
    PENDING_UPLOAD = 1,
    PARTIALLY_UPLOADED = 2,
    OVERDUE = 3,
    COMPLETED = 4,
    FAILED = 5,
}

export enum DropOffLinkType {
    COMPANY = 0,
    PERSONAL = 1,
    NONE = 2,
}

export enum RequestSource {
    Portal = 1,
    WebAddIn = 2,
}

export enum ShareFolderTypes {
    NONE = 0,
    VIEW = 1,
    EDIT = 2,
    REMOVE = -1,
}

export enum UpdateDropOffRecipientType {
    EnableRecipients = 1,
    DisableRecipients = 2,
    SetAsDefault = 3,
    RemoveAsDefault = 4,
}

export enum TabType {
    MessageOption = 0,
    AuthenticationQuestions=1,
    SupportContact=2,
    Configuration=3,
    User=4,
    MessageHistory=5,
    RequestHistory=6,
    DocumentCategory=7,
    RequestTemplate=8,
    MessageNotification=9,
    RequestNotification=10,
    ArchiveMessage= 11,
    ArchiveRequest=12,  
    MessageEmailTemplate=13,
    RequestsEmailTemplate=14,
    FolderNotification=15,
     ArchiveFiles = 16,
}

export enum DocumentRequestStatusHistoryReport {
    PendingUpload = 1,
    PartiallyUploaded = 2,
    Overdue = 3,
    Completed = 4,
    Expired = 5,
    Canceled = 6,
}

export enum FolderEventType {
    None = 0,
    Create = 1,
    Edit = 2
}

export enum DocumentCategorySortColumn {
    Name = 1,
    CreatedDate = 3,
}

export enum ShareFolderUserType {
    None = 0,
    User = 1,
    Group = 2
}

export enum NotifierTypes {
    Error,
    Success,
    Warning,
    Info,
    None
}

export enum TemplateType
{
    None =0,
    SecureMail = 1,
    DocumentRequest = 2
}

export enum TemplateSource
{
   None =0,
   SystemDefault =1,
   UserCreated = 2,
   AdminCreated =3
}

export enum FirmType {
    None = 0,
    Live = 1,
    Internal = 2,
}

export enum DeliveryType {
    Compose = 0,
    Reply = 1,
    ReplyAll = 2,
    Forward = 3,
    WebAddInCompose = 4,
    DropOff = 5,
    DocumentRequest = 6,
    DocumentRequestWebAddIn = 7,
    QuickReply = 8,
}

export enum MyFilesFileType {
    None = 0,
    ReceivedMessage = 1,
    SentMessage = 2,
    DocumentRequest = 3,
}